import * as React from "react";
import * as API from "../apiCalls";
import { Seat, Label, Price, Line, Spectacle } from "../types";

interface StateShape {
  isLoading: boolean;
  error: boolean;
  data: {
    seats: Seat[];
    labels: Label[];
    lines: Line[];
    spectacle: Spectacle;
    areaPrices: { [key: string]: Price[] };
    vatPrices: any;
  } | null;
}

export default function(spectacleId: number) {
  const [state, setState] = React.useState<StateShape>({
    isLoading: false,
    error: false,
    data: null,
  });
  function fetchData(id: number) {
    setState({
      isLoading: true,
      error: false,
      data: null,
    });

    API.fetchAudience(id)
      .then(response => {
        if (response.status === 200 || response.status === 304) {
          return response.json();
        }
        throw Error();
      })
      .then(result => {
        setState({
          isLoading: false,
          error: false,
          data: {
            seats: result.seats,
            labels: result.labels,
            areaPrices: result.areaPrices,
            lines: result.lines,
            spectacle: result.spectacle,
            vatPrices: null,
          },
        });
      })
      .catch(() => {
        setState({
          ...state,
          isLoading: false,
          error: true,
        });
      });
  }

  React.useEffect(() => {
    if (spectacleId) {
      fetchData(spectacleId);
    }
  }, [spectacleId]);

  if (!state.data) {
    return { state };
  }

  const xMax = Math.max(
    ...state.data.seats.map(seat => seat.X),
    ...state.data.labels.map(label => label.X),
    ...state.data.lines.map(line => line.X1),
    ...state.data.lines.map(line => line.X2),
  );

  const yMax = Math.max(
    ...state.data.seats.map(seat => seat.Y),
    ...state.data.labels.map(label => label.Y),
    ...state.data.lines.map(line => line.Y1),
    ...state.data.lines.map(line => line.Y2),
  );

  const xMin = Math.min(
    ...state.data.seats.map(seat => seat.X),
    ...state.data.labels.map(label => label.X),
    ...state.data.lines.map(line => line.X1),
    ...state.data.lines.map(line => line.X2),
  );
  const yMin = Math.min(
    ...state.data.seats.map(seat => seat.Y),
    ...state.data.labels.map(label => label.Y),
    ...state.data.lines.map(line => line.Y1),
    ...state.data.lines.map(line => line.Y2),
  );

  return {
    state,
    yMax,
    xMax,
    xMin,
    yMin,
  };
}
